import {createClient} from "contentful"

let contentfulClient = createClient ({
    space: '857folb0vp61',
    accessToken: 'UgTV_HDAbi4NNKi8NckYsu4xwVeOlo6XFrmhiV7xZnA'
})

export default contentfulClient;